
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import {
    changeUserStoreMoney,
    getOrderTable,
    getRecordDetail, getSpecialTotalList, getStoreTotalList,
    getUserProject,
    giveOutProject, permissionList,
    postOrderWriteOff
} from "@/api/http";
import { column } from "@/assets/types/common";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

type screen = {
    search: string;
    time: Array<string> | null;
    service: Array<number> | null;
};
type screenKey = keyof screen;
type order = {
    ordersn: string;
    create_time: string;
    project: string;
    classifcation: string;
    goodsprice: string;
    user_id: string;
    phone: number | null;
    pay_status_text: string;
    nucleus_pin_code: string;
    nucleus_pin_code_status: number;
    id: number;
};
const columnList: Array<column> = [
    {
        prop: "id",
        label: "会员ID",
        width: 90,
    },
    {
        prop: "nickname",
        label: "会员名称",
        width: 80,
    },
    {
        prop: "phone",
        label: "手机号",
        width: 80,
    },
    {
        prop: "wolf_bean",
        label: "狼豆",
        width: 80,
    },
    {
        prop: "balance",
        label: "余额",
        width: 80,
    },
    // {
    //     prop: "team_text",
    //     label: "团队人数",
    //     width: 80,
    // },
    // {
    //     prop: "agent_id",
    //     label: "上级用户",
    //     width: 80,
    // },
    {
        prop: "level",
        label: "等级",
        width: 80,
    },
    {
        prop: "cumulative",
        label: "消费金额",
        width: 80,
    },
    {
        prop: "vip_card_totals",
        label: "会员卡",
        width: 80,
    },
    {
        prop: "coupon_totals",
        label: "优惠券",
        width: 80,
    },
];
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "待审核",
        id: 0,
    },
    {
        name: "待打款",
        id: 1,
    },
    {
        name: "已打款",
        id: 2,
    },
];
export default defineComponent({
    name: "memberlist",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["会员管理", "会员列表"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<order>),
            total = ref(0),
            roleList = ref({} as any),
            is_admin = ref(false),
            loading = ref(true),
            dialog_show = ref(false),
            projectForm = reactive({
                phone:"",
                name:""
            }),
            //已购套餐列表
            projectsData = reactive({
                projectsDialogShow:false,
                projectsList:[],
            }),
            //消费记录
            recordData = reactive({
                recordDialogShow:false,
                recordList:[],
                total:0,
                page:1,
                pagesize:10,
                user_id:0
            }),
            yueData = reactive({
                yueDia_show:false,
                form:{
                    phone:'',
                    money:'',
                    payType:"",
                    is_save:1,
                    store_id:""
                },
                rules:{
                    phone: [{required: true, message: '必填', trigger: 'trigger'}],
                    money: [{required: true, message: '必填', trigger: 'trigger'}]
                },
                payTypeList:[],
                storeList:[]
            }),
            //尊享卡列表
            vipCardData = reactive({
                recordDialogShow:false,
                recordList:[],
                total:0,
                page:1,
                pagesize:10,
                user_id:0
            }),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as screen),
            orderStatus = ref(0),
            screenParameter: any = ref({
                page: currentPage.value,
                pagesize: pageSize.value,
                admin_status: orderStatusNav[orderStatus.value].id,
                type: 1,
            } as any),
            dialog_model = ref(""),
            dialog_index = ref(0),
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ]),
            project = ref([]),
            dialogFormVisible = ref(false),
            cardDetailData = ref([] as Array<any>),
            orderDetail = ref({} as order),
            dialogNavIndex = ref(0),
            cardList = ref([]),
            dialogVisible = ref(false),
            _userdetail = (i: number) => {
                dialog_index.value = i;
                dialog_model.value = "userdetail";
                Request.axiosInstance({
                    url: "adminapi/User/getUserCouponVip",
                    data: { user_id: tableData.value[i].user_id, status: 2 },
                }).then((res: any) => {
                    cardList.value = res?.content?.list || [];
                });
            },
            _withdrawalAudit = (id: number, status: number) => {
                Request.axiosInstance({
                    url: "adminapi/Withdrawal/withdrawalAudit",
                    data: { id, status },
                }).then((res: any) => {
                    res.status == 202 && getTableData();
                });
            },
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
            formRef = ref(null);

        let getTableData = () => {
                let mydata = {
                    type:1,
                    role_name:'member_list',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                loading.value = true;
                screenParameter.value.status =
                    orderStatusNav[orderStatus.value].id;
                Request.axiosInstance({
                    url: "adminapi/User/list",
                    data: {...screenParameter.value,page:currentPage.value,pagesize:pageSize.value},
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    project.value = res?.content?.project || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            //查看余额详情
            recordDetail = ((user_id:number)=>{
                recordData.user_id = user_id;
                recordData.page = 1;
                getRecordList();
            }),
            //查看尊享卡列表
            vipCardList = ((user_id:number)=>{
                Request.axiosInstance({
                    url: "adminapi/User/getUserCouponVip",
                    data: { user_id: user_id, status: 2 },
                }).then((res: any) => {
                    cardList.value = res?.content?.list || [];
                    dialogVisible.value = true;
                });
                
            }),
            //查看已购项目列表
            projectsListClick = ((user_id:number)=>{
                getUserProject({user_id}).then((res: any)=>{
                    projectsData.projectsDialogShow = true;
                    projectsData.projectsList = res?.content?.list || [];
                });
            }),
            handleSizeChange = (pagesize: number): void => {
                pageSize.value = pagesize;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            recordSizeChange = (pagesize: number): void => {
                recordData.pagesize = pagesize;
                getRecordList();
            },
            recordCurrentChange = (page: number): void => {
                recordData.page = page;
                getRecordList();
            },
            getRecordList = (()=>{
                getRecordDetail({user_id:recordData.user_id,page:recordData.page,pagesize:recordData.pagesize}).then((res:any)=>{
                    recordData.recordDialogShow = true;
                    recordData.recordList = res.content.list;
                    recordData.total = res.content.total;
                })
            }),
			columnUserChange = (item: any): void => {
				Request.axiosInstance({
					url: 'adminapi/Order/delCarUser',
					data: {
						order_id: item.id,
						type:2
					},
				}).then((res: any) => {
					getTableData();
				});
            },
            selectChange = (e: string | Array<Date> | Array<number>, key: screenKey): void => {
                if (!e) {
                    if (key == "service") {
                        delete screenParameter["project_type_pid"];
                        delete screenParameter["project_id"];
                    } else if (key == "time") {
                        delete screenParameter["start_time"];
                        delete screenParameter["end_time"];
                    } else {
                        delete screenParameter[key];
                    }
                } else {
                    if (key == "service") {
                        screenParameter["project_type_pid"] = e[0];
                        screenParameter["project_id"] = e[1];
                    } else if (key == "time") {
                        screenParameter["start_time"] =
                            (e[0] as Date).getTime() / 1000;
                        screenParameter["end_time"] =
                            (e[1] as Date).getTime() / 1000;
                    } else {
                        screenParameter[key] = e;
                    }
                }
                getTableData();
            },
            //查看尊享卡详情
            toDetail = (item: any) => {
                dialogFormVisible.value = true;
                Request.axiosInstance({
                    url: "adminapi/VipClass/getOrderVipClassList",
                    data: {
                        id: item.id,
                    },
                }).then((res: any) => {
                    cardDetailData.value = res?.content?.list || [];
                });
            },
            submitClick = ()=>{
                dialog_show.value = true;
            },
            giveMoneyClick = ()=>{
                yueData.yueDia_show = true;
            },
            giveSubmit = ()=>{
            if (is_admin.value  && !yueData.form.store_id){
                return alert('总店发放余额要选门店');
            }
            if (yueData.form.phone==''){
                return alert('请输入号码');
            }
                if (yueData.form.money==''){
                    return alert('请输入金额');
                }
                loading.value = true;
                let data = {
                    phone: yueData.form.phone,
                    money: yueData.form.money,
                    payType: yueData.form.payType,
                    is_save: yueData.form.is_save,
                    store_id: yueData.form.store_id
                }
                changeUserStoreMoney(data).then((res: any) => {
                    if (res.status==202){
                        yueData.yueDia_show = false;
                    }
                    loading.value = false;
                })
            },
            _formSubmit = ()=> {
    
                Request.axiosInstance({
                    url: 'adminapi/User/addUserByServe',
                    data: {
                        ...projectForm
                    },
                }).then((res: any) => {
                    if (res.status==200){
                        dialog_show.value = false;
                        getTableData();
                    }
                    
                });
            },
            check = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    console.log(valid);
                    if (valid) {
                        postOrderWriteOff({
                            order_id: orderDetail.value.id,
                            nucleus_pin_code:
                                orderDetail.value.nucleus_pin_code,
                        }).then((res) => {
                            if (res.status == 202) {
                                orderDetail.value.pay_status_text = "已完成";
                                orderDetail.value.nucleus_pin_code_status = 1;
                                getTableData();
                            }
                        });
                    }
                });
            };
        onMounted(() => {
            let info;
            let user_info = localStorage.getItem('user_info');
            if (user_info) {
                info = JSON.parse(user_info);
                if (info.store_id==0){
                    is_admin.value = true;
                }
            }
            getStoreTotalList({}).then((res:any)=>{
                yueData.storeList = res.content.list;
            });
            getTableData();
            getSpecialTotalList({basicset_type:3}).then((res:any)=>{
                yueData.payTypeList = res.content.list;
            });
        });
        // watch(orderStatus, (newValue, oldValue) => {
        //     screenParameter.status = orderStatusNav[newValue].id;
        //     getTableData();
        // });
        return {
            headClass,
            columnList,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            orderStatusNav,
            orderStatus,
            screen,
            shortcuts,
            project,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            rules,
            formRef,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            yueData,
            columnUserChange,
            giveMoneyClick,
            check,
            screenParameter,
            _withdrawalAudit,
            _userdetail,
            dialog_model,
            dialog_index,
            cardList,
            dialogVisible,
            roleList,
            recordData,
            giveSubmit,
            recordDetail,
            recordSizeChange,
            recordCurrentChange,
            projectsListClick,
            projectsData,
            submitClick,
            projectForm,
            dialog_show,
            _formSubmit,
            vipCardList,
            toDetail,
            cardDetailData,
            is_admin
        };
    },
    mounted() {},
    methods: {
        a() {
            // (this.print as any).click()
            //  (this as any).$print(this.print)
        },
    },
});
